
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"45","viewBox":"0 0 45 45","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.01 38.516H11.004a5.502 5.502 0 01-5.503-5.502v-22.01a5.502 5.502 0 015.503-5.502h22.009a5.502 5.502 0 015.502 5.503v11.004","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M31.373 30.1v2.58l2.545 1.238","stroke":"#EE8F00","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M32.008 39.01a6.998 6.998 0 01-6.999-7 7.106 7.106 0 017.005-7 6.998 6.998 0 016.056 10.502 6.998 6.998 0 01-6.062 3.497z","stroke":"#363636","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M38.516 14.673H5.502","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M25.217 21a.09.09 0 100 .18.09.09 0 000-.18M18.798 21a.088.088 0 00-.088.09.09.09 0 10.088-.09M12.378 21a.088.088 0 00-.09.092.09.09 0 00.155.063.09.09 0 00-.066-.153M18.798 26.503a.088.088 0 00-.088.09.09.09 0 10.088-.09M12.378 26.503a.088.088 0 00-.09.091.09.09 0 10.089-.09M18.798 32.007a.088.088 0 00-.088.09.09.09 0 10.088-.09M12.378 32.007a.088.088 0 00-.09.09.09.09 0 10.088-.09","stroke":"#363636","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    